var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"required props-group"},[_c('el-form-item',{attrs:{"label":"必填"}},[_c('el-checkbox',{model:{value:(_vm.component.properties.required),callback:function ($$v) {_vm.$set(_vm.component.properties, "required", $$v)},expression:"component.properties.required"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33a89d1a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/componentAttr/required.vue
// module id = null
// module chunks = 